if ( typeof ShippingNotice !== 'function' ) {

  class ShippingNotice extends HTMLElement {

    constructor() {
      super();
      this.init();
      this.observeTotal();
    }

    // On the cart page this element sits above the two column grid, outside the
    // container the cart JS re-renders, so it cannot pick up a new total on its
    // own. That container carries the fresh total in a hidden marker; watch it
    // and re-render from there. Path independent, unlike the 'cart-updated'
    // event, which only fires on one of the update routes.
    observeTotal() {

      const source = this.getAttribute('data-observe-total');
      if ( !source ) return;

      const container = document.querySelector(source);
      if ( !container ) return;

      new MutationObserver(() => {
        const marker = container.querySelector('[data-cart-total-cents]');
        if ( !marker ) return;
        const total = marker.getAttribute('data-cart-total-cents');
        if ( total === this.getAttribute('data-cart-total-amount') ) return;
        this.setAttribute('data-cart-total-amount', total);
        this.init();
      }).observe(container, { childList: true, subtree: true });

    }

    init() {

      const freeShippingThreshold = Number(this.getAttribute('data-free-shipping'));
      const cartTotal = Number(this.getAttribute('data-cart-total-amount'));
      const freeShippingRemaining = cartTotal - Math.round(freeShippingThreshold * (Shopify.currency.rate ? Number(Shopify.currency.rate) : 1));
      let shippingMessage = '';
      let shippingSuccess = false

      if ( freeShippingRemaining < 0 ) {
        shippingMessage = window.KROWN.settings.locales.shipping_notice_remaining_to_free.replace('{{ remaining_amount }}', this._formatMoney(Math.abs(freeShippingRemaining), KROWN.settings.shop_money_format));

      } else {
        shippingMessage = window.KROWN.settings.locales.shipping_notice_eligible_for_free;
        shippingSuccess = true;
      }

      // How far the cart has come towards the threshold, as a percentage.
      const threshold = Math.round(freeShippingThreshold * (Shopify.currency.rate ? Number(Shopify.currency.rate) : 1));
      const progress = threshold > 0 ? Math.min(Math.round(cartTotal / threshold * 100), 100) : 100;

      this.classList.toggle(`${(window.KT_PREFIX || '')}shipping-notice--reached`, shippingSuccess);

      this.innerHTML = `
        <div class="shipping-notice__text">${shippingMessage}</div>
        <div class="shipping-notice__track" role="progressbar" aria-valuemin="0" aria-valuemax="100" aria-valuenow="${progress}">
          <span class="shipping-notice__fill" style="width: ${progress}%"></span>
        </div>`;

    }
    
    _formatMoney(cents, format) {

			if (typeof cents === 'string') {
				cents = cents.replace('.', '');
			}
	
			let value = '';
			const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
			const formatString = format || moneyFormat;
	
			function formatWithDelimiters(number, precision, thousands, decimal) {
				thousands = thousands || ',';
				decimal = decimal || '.';
	
				if (isNaN(number) || number === null) {
					return 0;
				}
	
				number = (number / 100.0).toFixed(precision);
	
				const parts = number.split('.');
				const dollarsAmount = parts[0].replace(
					/(\d)(?=(\d\d\d)+(?!\d))/g,
					'$1' + thousands
				);
				const centsAmount = parts[1] ? decimal + parts[1] : '';
	
				return dollarsAmount + centsAmount;
			}
	
			switch (formatString.match(placeholderRegex)[1]) {
				case 'amount':
					value = formatWithDelimiters(cents, 2);
					break;
				case 'amount_no_decimals':
					value = formatWithDelimiters(cents, 0);
					break;
				case 'amount_with_comma_separator':
					value = formatWithDelimiters(cents, 2, '.', ',');
					break;
				case 'amount_no_decimals_with_comma_separator':
					value = formatWithDelimiters(cents, 0, '.', ',');
					break;
				case 'amount_no_decimals_with_space_separator':
					value = formatWithDelimiters(cents, 0, ' ');
					break;
				case 'amount_with_apostrophe_separator':
					value = formatWithDelimiters(cents, 2, "'");
					break;
			}
	
			return formatString.replace(placeholderRegex, value);
	
		}

  }

  if ( typeof customElements.get('shipping-notice') == 'undefined' ) {
    customElements.define('shipping-notice', ShippingNotice);
  }

}